import { isEmpty } from "lodash";
import React from "react";
import { Tag } from "../../common/UIComponents";
import PropTypes from "prop-types";
import { TagCloseIcon } from "../../common/CustomIcon";

const FilterTag = (props) => {
  const {
    children,
    InternationalizationText,
    onClose,
    filterValue,
    closable,
    ...rest
  } = props;
  if (!isEmpty(filterValue)) {
    return (
      <Tag
        onClose={ onClose }
        className="filteredTagStyle"
        { ...rest }
      >
        { InternationalizationText }: { children } &nbsp;

       {closable && <TagCloseIcon
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            cursor: "pointer",
            fontSize: "16px",
            color: "#576ec1", 
          }}
          onClick={onClose}
        />}
      </Tag>
    );
  } else {
    return null;
  }
}
export default FilterTag;

FilterTag.defaultProps = {
  closable: true,
  onClose: () => {},
  filterValue: "",
  children: "",
  InternationalizationText: "",
};
FilterTag.propTypes = {
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  filterValue: PropTypes.string,
  children: PropTypes.string,
  InternationalizationText: PropTypes.string,
};